<template>
	<transition name="error">
		<div class="operators" @scroll="scrollPopup">
			<button @click="add">добавить новый оператор</button>
			<p class="right">список операторов</p>
			<transition name="error">
				<p class="exist isOk" v-if="savedSuccess">успешно сохранено!</p>
				<p class="exist" v-if="error">ошибка при добавлении оператора!</p>
				<p class="exist isOk" v-if="deleteOk">оператор успешно удален</p>
				<p class="exist" v-if="errorDelete">оператор не был удален</p>
			</transition>
			<add-new-operator :addNewOperator="addNewOperator"
			                  @hiddenNewOper="hidden($event)"
			                  id="add"/>
			<delete-operator :operatorDelete="operatorDelete"
			                 @hiddenDeleteOper="hidden($event)"
			                 @hasDepend="hasDepend"
			                 id="remove"/>
			<edit-operator :editOperatorPropsShow="editOperatorPropsShow"
			               :editOperatorPropsOperator="editOperatorPropsOperator"
			               :editOperatorPropsOperatorOld="oldName"
			               @hiddenNewOper="hidden($event)"
			               id="edit"/>
			<depend-operator v-if="depend"
			        @hasDepend="hasDepend"/>
			<div class="container">
				<div class="row justify-content-between p-2 pl-5 pb-2 card-header">
					<span class="w-25 h5">имя</span>
					<span class="w-25 h5">отображаемое имя</span>
					<span class="w-25 h5">URL</span>
					<span class="w-25"></span>
				</div>
				<div>
					<div class="row justify-content-between p-2 pl-5 list"
					     v-for="operator in operatorList"
					     :key="operator.display_name">
						<span class="w-25">{{operator.name}}</span>
						<span class="w-25">{{operator.display_name}}</span>
						<span class="w-25">{{operator.api_url}}</span>
						<span class="w-25 text-center">
					<button
						class="btn btn-danger mt-1" @click="showDeletePopup(operator.name, true)">delete
					</button>
					<button
						class="btn btn-outline-info mt-1" @click="editOperator(operator)">edit
					</button>
				</span>
					</div>
				</div>
			</div>
		</div>
	</transition>
</template>
<script>
	import { performRequest } from "../script/ws/wsclient";
	import AddNewOperator     from "./AddNewOperator";
	import DeleteOperator     from "./DeleteOperator";
	import EditOperator       from "./EditOperator";
	import { mapGetters }     from "vuex";
	import DependOperator             from "./DependOperator";

	export default {
		name:       "Operators",
		components: {
			DependOperator,
			EditOperator,
			DeleteOperator,
			AddNewOperator
		},
		data() {
			return {
				savedSuccess:              false,
				error:                     false,
				errorDelete:               false,
				deleteOk:                  false,
				operatorList:              [],
				addNewOperator:            false,
				operatorDelete:            {
					name: "",
					show: false
				},
				editOperatorPropsShow:     false,
				editOperatorPropsOperator: {},
				oldName:                   "",
				depend: false
			};
		},
		beforeMount() {
			this.getOper();
		},
		computed:   {
			...mapGetters(["getViewUser"])
		},
		methods:    {
			getOper() {
				performRequest(
					{
						section: "tvcontent.operator",
						name:    "getOperatorList"
					},
					{
						operator: this.getViewUser
					},
					a => {
						if (a.code === 200) {
							this.operatorList = a.data;
							console.log(a);
						} else {
							console.log("ошибка загрузки списка операторов");
						}
					});
			},
			hidden(event) {
				this.addNewOperator                                  = event.show;
				this.operatorDelete.show                             = event.show;
				this.editOperatorPropsShow                           = event.show;
				document.querySelector(".operators").style.overflowY = "scroll";
				if (event.getOper) {
					this.getOper();
				}
			},
			add() {
				this.addNewOperator                                  = true;
				document.querySelector(".operators").style.overflowY = "hidden";
			},
			scrollPopup() {
				let elem        = document.querySelector(".operators");
				let addedPopup  = document.querySelector("#add");
				let deletePopup = document.querySelector("#remove");
				let editPopup   = document.querySelector("#edit");
				console.log(deletePopup);
				addedPopup.style.top  = elem.scrollTop + "px";
				deletePopup.style.top = elem.scrollTop + "px";
				editPopup.style.top   = elem.scrollTop + "px";
			},
			showDeletePopup(val1, val2) {
				this.operatorDelete.name                             = val1;
				this.operatorDelete.show                             = val2;
				document.querySelector(".operators").style.overflowY = "hidden";
			},
			editOperator(operator) {
				this.editOperatorPropsShow                           = true;
				this.editOperatorPropsOperator                       = operator;
				this.oldName                                         = operator.name;
				document.querySelector(".operators").style.overflowY = "hidden";
			},
			hasDepend() {
				this.operatorDelete.show = false;
				this.depend = !this.depend
			}
		}
	};
</script>
<style scoped lang="scss">
	@import "~bootstrap/scss/bootstrap";
	$width_container_button: 24px;
	$width_button_item: $width_container_button - 8;
	$height_button: 2px;
	$height_add: 208px;
	$width_add: $height_add / 4;
	$bd_button: 8px;
	.operators {
		background-color: rgba(238, 238, 200, 0.8);
		box-shadow: inset 0 0 5px rgba(51, 51, 51, 0.4), 1px 1px 5px #333;
		/*padding: 0.5rem 0.5rem 1rem 0.5rem;*/
		height: calc(100vh - 5rem);
		overflow: auto;
		position: absolute;
		margin-top: 4rem;
		width: 90%;
		right: 50%;
		min-width: 700px;
		max-width: 1200px;
		transform: translateX(50%);
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		justify-content: flex-start;
		align-items: flex-start;
		align-content: flex-start;
		.right {
			position: absolute;
			top: 7px;
			right: 20px;
		}
	}
	.exist {
		background-color: rgba(238, 160, 154, 0.6);
		border-radius: 5px;
		padding: 4px 10px 5px 10px;
		top: 6px;
		font-weight: bold;
		position: absolute;
		margin-left: 30%;
		color: #940000;
		font-size: 1.1rem;
		z-index: 1000;
	}
	.isOk {
		background-color: rgba(137, 238, 154, 0.6);
		color: #008d94;
	}
	.btn {
		padding: 0 1rem;
		height: 3rem;
		min-width: 5rem;
		margin: 0;
	}
	.list {
		border-top: 1px solid rgba(44, 62, 80, 0.47);
		transition: background-color .3s;
		&:hover {
			background-color: rgba(128, 140, 166, 0.33);
		}
		&:last-child {
			border-bottom: 1px solid rgba(44, 62, 80, 0.47);
		}
		
	}
	.label {
		width: 200px;
	}
	.main {
		background-color: rgba(130, 130, 130, 0.27);
	}
	.input {
		width: 70%;
		height: 1.8rem;
		outline: none;
		border: 1px solid gray;
		border-radius: 3px;
		transition: all .3s;
		padding-left: 5px;
		&:focus {
			border: 1px solid #acafff;
			box-shadow: 0 0 7px #acafff;
		}
	}
	.popup {
		top: 50%;
		transform: translateY(-50%);
	}
	.err_handler {
		bottom: 1.5rem;
		font-size: 1.1rem;
		left: 3.8rem;
	}
	button {
		background: #bbf291;
		border-radius: 0.2rem;
		line-height: 1.8rem;
		margin: 1rem;
		border: none;
		outline: none;
		height: 2.5rem;
		padding: 0.2rem 1rem;
		transition: all 0.2s;
		cursor: pointer;
		max-height: 2rem;
		&:hover {
			background: #78956b;
			color: white;
			
			&:active {
				box-shadow: 0 0 1rem #967068;
			}
		}
	}
	@media (max-width: 620px) {
		.operators {
			height: calc(100vh - 9rem);
			min-width: 700px;
			margin-top: 8rem;
			overflow: auto;
		}
	}
	.error-enter-active {
		transition: all 0.5s ease;
	}
	.error-leave-active {
		transition: all 0.5s ease;
	}
	.error-enter,
	.error-leave-to {
		opacity: 0;
	}
</style>



// WEBPACK FOOTER //
// src/components/Operators.vue